import axios from '../axios';
import { ApiEnvelope, ProviderDto } from './types';

export const ownerFavoriteService = {
  getFavoriteProviders: async (limit = 100, offset = 1): Promise<ProviderDto[]> => {
    const response = await axios.get<ApiEnvelope<any>>(`/v1/customer/favorite/provider-list?limit=${limit}&offset=${offset}`);
    return response.data.content?.data || response.data.content || [];
  },

  addFavoriteProvider: async (data: { providerId: string; servicemanId?: string }): Promise<void> => {
    await axios.post('/v1/customer/favorite/provider', { provider_id: data.providerId, serviceman_id: data.servicemanId });
  },
    

  removeFavoriteProvider: async (data: { providerId: string; servicemanId?: string }): Promise<void> => {
    let url = `/v1/customer/favorite/provider-destroy/${data.providerId}`;
    if (data.servicemanId) url += `?serviceman_id=${data.servicemanId}`;
    await axios.post(url);
  },
    
};
